import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Blogdetail from "./Components/Blog/Blogdetail";
import Scroll from "./Components/Scroll";
import Main from "./Components/Main";
import Portfolionext from "./Components/Portfolio/Portfolionext";

import "./App.css";

function App() {
  return (
    <>
      <Router>
        <Scroll />
        <Switch>
          <Route path="/MyPortfolio" component={Portfolionext} />
          <Route path="/Blogdetail" component={Blogdetail} />
          <Route to="/" component={Main} />
        </Switch>
      </Router>
    </>
  );
}

export default App;